import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from "react-dom/client";
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import store from './store'
const root = ReactDOM.createRoot(document.getElementById("root"));

import { registerLicense } from '@syncfusion/ej2-base';
import { SidebarProvider } from './components/SidebarContext';
import IndexedDBProvider from './context/IndexedContext';
registerLicense(
  'Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXtecnRTRWJcUUxxV0RWYUA='
);

root.render(

  <Provider store={store}>
    <SidebarProvider>
      <IndexedDBProvider>
    <App />
      </IndexedDBProvider>
    </SidebarProvider>
  </Provider>

  
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
